import React, { useEffect, useState } from "react";
import FileDownload from "js-file-download";
import axios from "axios";

// const env = import.meta.env;
// export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

//Fetch Cyber Security Appendix List
export const fetchCyberSecurityAppendixList = async (riskPlanID: any) => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/api/Plan/RiskManagment/Appendix/CyberSecurity/${riskPlanID}/Details`
    );

    // console.log("fetchCyberSecurityAppendixList res", res);
    return res.data.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Fetch Supply Chain Appendix List
export const fetchSupplyChainAppendixList = async (riskPlanID: any) => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/api/Plan/RiskManagment/Appendix/SupplyChain/${riskPlanID}/Details`
    );

    // console.log("fetchSupplyChainAppendixList res", res);
    return res.data.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Fetch Appendix List
export const fetchAppendixList = async (
  isCyberSecurity: boolean,
  riskPlanID: any
) => {
  const res = isCyberSecurity
    ? await fetchCyberSecurityAppendixList(riskPlanID)
    : await fetchSupplyChainAppendixList(riskPlanID);
  return res;
};

//Fetch Cyber Security Appendix List
export const fetchCyberSecurityAppendixDetails = async (appendixId: number) => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/api/Plan/RiskManagment/Appendix/CyberSecurity/Id/${appendixId}/Details`
    );

    // console.log("fetchCyberSecurityAppendixDetails res", res);
    return res.data.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Fetch Supply Chain Appendix Details
export const fetchSupplyChainAppendixDetails = async (appendixId: number) => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/api/Plan/RiskManagment/Appendix/SupplyChain/Id/${appendixId}/Details`
    );

    // console.log("fetchSupplyChainAppendixList res", res);
    return res.data.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Fetch Appendix Details
export const fetchAppendixDetails = async (
  isCyberSecurity: boolean,
  appendixId: number
) => {
  const res = isCyberSecurity
    ? await fetchCyberSecurityAppendixDetails(appendixId)
    : await fetchSupplyChainAppendixDetails(appendixId);
  return res;
};

//Create Cyber Security Appendix
export const createCyberSecurityAppendix = async (payload: any) => {
  try {
    const res = await axios.post(
      `${API_BASE_URL}/api/Plan/RiskManagment/Appendix/CyberSecurity/Create`,
      payload
    );
    // console.log("createCyberSecurityAppendix res", res);
    return res.data;
  } catch (error) {
    // console.log("@@Error:", error);
    return error;
  }
};

//Create Supply Chain Appendix
export const createSupplyChainAppendix = async (payload: any) => {
  try {
    const res = await axios.post(
      `${API_BASE_URL}/api/Plan/RiskManagment/Appendix/SupplyChain/Create`,
      payload
    );
    // console.log("createSupplyChainAppendix res", res);
    return res.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Create Appendix
export const createAppendix = async (
  isCyberSecurity: boolean,
  payload: any
) => {
  const res = isCyberSecurity
    ? await createCyberSecurityAppendix(payload)
    : await createSupplyChainAppendix(payload);
  return res;
};

//Create Multiple Cyber Security Appendix
export const createCyberSecurityAppendixList = async (payload: any) => {
  try {
    const res = await axios.post(
      `${API_BASE_URL}/api/Plan/RiskManagment/Appendix/CyberSecurity/list/Create`,
      payload
    );
    // console.log("createCyberSecurityAppendix res", res);
    return res.data;
  } catch (error) {
    // console.log("@@Error:", error);
    return error;
  }
};

//Create Multiple Supply Chain Appendix
export const createSupplyChainAppendixList = async (payload: any) => {
  try {
    const res = await axios.post(
      `${API_BASE_URL}/api/Plan/RiskManagment/Appendix/SupplyChain/list/Create`,
      payload
    );
    // console.log("createSupplyChainAppendix res", res);
    return res.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Create Multiple Appendix
export const createAppendixList = async (
  isCyberSecurity: boolean,
  payload: any
) => {
  const res = isCyberSecurity
    ? await createCyberSecurityAppendixList(payload)
    : await createSupplyChainAppendixList(payload);
  return res;
};

//Update Cyber Security Appendix
export const updateCyberSecurityAppendix = async (payload: any) => {
  try {
    const res = await axios.put(
      `${API_BASE_URL}/api/Plan/RiskManagment/Appendix/CyberSecurity/Update`,
      payload
    );
    // console.log("updateCyberSecurityAppendix res", res);
    return res.data;
  } catch (error) {
    // console.log("@@Error:", error);
    return error;
  }
};

//Update Supply Chain Appendix
export const updateSupplyChainAppendix = async (payload: any) => {
  try {
    const res = await axios.put(
      `${API_BASE_URL}/api/Plan/RiskManagment/Appendix/SupplyChain/Update`,
      payload
    );
    // console.log("updateSupplyChainAppendix res", res);
    return res.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Update Appendix
export const updateAppendix = async (
  isCyberSecurity: boolean,
  payload: any
) => {
  const res = isCyberSecurity
    ? await updateCyberSecurityAppendix(payload)
    : await updateSupplyChainAppendix(payload);
  return res;
};

//Update Multiple Cyber Security Appendix
export const updateCyberSecurityAppendixList = async (payload: any) => {
  try {
    const res = await axios.put(
      `${API_BASE_URL}/api/Plan/RiskManagment/Appendix/CyberSecurity/list/Update`,
      payload
    );
    // console.log("updateCyberSecurityAppendix res", res);
    return res.data;
  } catch (error) {
    // console.log("@@Error:", error);
    return error;
  }
};

//Update Multiple Supply Chain Appendix
export const updateSupplyChainAppendixList = async (payload: any) => {
  try {
    const res = await axios.put(
      `${API_BASE_URL}/api/Plan/RiskManagment/Appendix/SupplyChain/list/Update`,
      payload
    );
    // console.log("updateSupplyChainAppendix res", res);
    return res.data;
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Update Multiple Appendix
export const updateAppendixList = async (
  isCyberSecurity: boolean,
  payload: any
) => {
  const res = isCyberSecurity
    ? await updateCyberSecurityAppendixList(payload)
    : await updateSupplyChainAppendixList(payload);
  return res;
};

//Delete Cyber Security Appendix
export const deleteCyberSecurityAppendix = async (
  appendixId: number,
  updatedBy: number
) => {
  try {
    const res = await axios.put(
      `${API_BASE_URL}/api/Plan/RiskManagment/Appendix/CyberSecurity/Delete/${appendixId}/${updatedBy}`
    );
    // console.log("deleteCyberSecurityAppendix res", res);
    return res.data;
  } catch (error) {
    // console.log("@@Error:", error);
    return error;
  }
};

//Delete Supply Chain Appendix
export const deleteSupplyChainAppendix = async (
  appendixId: number,
  updatedBy: number
) => {
  try {
    const res = await axios.put(
      `${API_BASE_URL}/api/Plan/RiskManagment/Appendix/SupplyChain/Delete/${appendixId}/${updatedBy}`
    );
    // console.log("deleteSupplyChainAppendix res", res);
    return res.data;
  } catch (error) {
    // console.log("@@Error:", error);
    return error;
  }
};

//Delete Appendix
export const deleteAppendix = async (
  isCyberSecurity: boolean,
  userId: number,
  appendixId: number
) => {
  const res = isCyberSecurity
    ? await deleteCyberSecurityAppendix(appendixId, userId)
    : await deleteSupplyChainAppendix(appendixId, userId);
  return res;
};

//Download Cyber Security Appendix
export const downloadCyberSecurityAppendix = async (
  payload: any,
  compnayProfileID: number
) => {
  try {
    axios({
      url: `${API_BASE_URL}/api/Plan/RiskManagment/Appendix/GenerateAppendixDocument?CSRiskManagementPlanAppendixID=${payload.csRiskManagementPlanAppendixID}&companyProfileid=${compnayProfileID}`,
      method: "GET",
      responseType: "blob",
    }).then((response) => {
      // console.log("downloadCyberSecurityAppendix res", payload, response);
      FileDownload(response.data, `${payload.title}.docx`);
    });
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Download Supply Chain Appendix
export const downloadSupplyChainAppendix = async (
  payload: any,
  compnayProfileID: number
) => {
  try {
    axios({
      url: `${API_BASE_URL}/api/Plan/RiskManagment/Appendix/GenerateSCAppendixDocument?SCRiskManagementPlanAppendixID=${payload.scRiskManagementPlanAppendixID}&compnayProfileid=${compnayProfileID}`,
      method: "GET",
      responseType: "blob",
    }).then((response) => {
      // console.log("downloadSupplyChainAppendix res", payload, response);
      FileDownload(response.data, `${payload.title}.docx`);
    });
  } catch (error) {
    console.log("@@Error:", error);
    return error;
  }
};

//Download Appendix
export const downloadAppendix = async (
  isCyberSecurity: boolean,
  payload: any,
  companyProfileId: number
) => {
  const res = isCyberSecurity
    ? await downloadCyberSecurityAppendix(payload, companyProfileId)
    : await downloadSupplyChainAppendix(payload, companyProfileId);
  return res;
};

//Fetch Cyber Security Appendix Import List
export const fetchCyberSecurityAppendixImportList = async () => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/api/Plan/RiskManagment/AppendixTemplate/CyberSecurity//Details`
    );
    // console.log("fetchCyberSecurityAppendixImportList res", res);
    return res.data.data;
  } catch (error) {
    // console.log("@@Error:", error);
    return error;
  }
};

//Fetch Supply Chain Appendix Import List
export const fetchSupplyChainAppendixImportList = async () => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}/api/Plan/RiskManagment/AppendixTemplate/SupplyChain//Details`
    );
    // console.log("fetchSupplyChainAppendixImportList res", res);
    return res.data.data;
  } catch (error) {
    // console.log("@@Error:", error);
    return error;
  }
};

//Fetch Appendix Import List
export const fetchAppendixImportList = async (isCyberSecurity: boolean) => {
  const res = isCyberSecurity
    ? await fetchCyberSecurityAppendixImportList()
    : await fetchSupplyChainAppendixImportList();
  return res;
};
